// src/config/seasonal.js
export const IS_CHRISTMAS = process.env.REACT_APP_EVENT_SEASON === "christmas";
export const IS_HALLOWEEN = process.env.REACT_APP_EVENT_SEASON === "halloween";
export const IS_DIWALI = process.env.REACT_APP_EVENT_SEASON === "diwali";
export const IS_NEW_YEAR = process.env.REACT_APP_EVENT_SEASON === "newyear";
export const IS_RAMADAN = process.env.REACT_APP_EVENT_SEASON === "ramadan";
export const IS_SINHALA_TAMIL_NEW_YEAR = process.env.REACT_APP_EVENT_SEASON === "sinhalatamilnewyear";